export const RelaxError = (props: any) => {
    return  <div className="error" key={props.index}>{props.error}</div>
}

const RelaxErrors = (props: any) => {
    if (!props.errors || props.errors.length === 0) return null;
    return props.errors.map((e: any, i: any) => <RelaxError key={i} error={e} index={i} />)
}

export default RelaxErrors;